import { Button, Form, Modal } from 'react-bootstrap';
import React, { useState } from 'react';
import { toast } from 'react-toastify';
import { IInvoice } from 'src/types/invoice';
import classNames from 'classnames';
import styles from '../assets/invoice-grid.module.scss';
import { saveInvoiceNote } from '../../../../../../../store/actions/invoice-actions';
import { useDispatch } from 'react-redux';

interface Props {
    original: IInvoice;
    setInvoiceNotes: any;
    invoiceNotes: any;
}

const EditNoteInvoice: React.FunctionComponent<Props> = ({ original, setInvoiceNotes, invoiceNotes }: Props) => {
    const [openedAddNote, setOpenedAddNote] = useState(false);
    const [note, setNote] = useState(original && original?.note ? original?.note : '');

    const dispatch = useDispatch();

    const handleSaveNote = () => {
        dispatch(
            saveInvoiceNote(
                { id: original?.id, note },
                {
                    resolve: () => {
                        const items = invoiceNotes;
                        items[original?.id] = note;
                        setInvoiceNotes(items);
                        toast.success('The note updated successfully.');
                        setOpenedAddNote(false);
                    },
                    reject: (errorMessage: string) => {
                        toast.error(errorMessage);
                    },
                },
            ),
        );
    };

    return (
        <div className={classNames(styles.note)}>
            <div>
                <button className={'btn btn-outline-info'} onClick={() => setOpenedAddNote(true)}>
                    edit
                </button>
            </div>
            <div>{invoiceNotes[original?.id] ? invoiceNotes[original?.id] : original?.note}</div>

            <Modal show={openedAddNote} onHide={() => setOpenedAddNote(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Invoice note #{original?.id}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form.Group>
                        <Form.Label>Note</Form.Label>
                        <Form.Control
                            as="textarea"
                            style={{ color: 'black' }}
                            rows={3}
                            value={note}
                            maxLength={250}
                            onChange={(e) => {
                                if (e.target.value.length <= 250) {
                                    setNote(e.target.value);
                                }
                            }}
                        />
                    </Form.Group>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setOpenedAddNote(false)}>
                        No, cancel
                    </Button>
                    <Button variant="success" onClick={handleSaveNote}>
                        Yes, save
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
};

export default EditNoteInvoice;
